namespace Solovis.Reports.ParameterTypes {

    export var _parameterTypeToParameterControlMap = {

        "annualizationMethod": "Solovis.Reports.Parameters.AnnualizationMethodParameterControl",

        "assetSelectionSet": "Solovis.Reports.Parameters.AssetSelectionSetParameterControl",

        "bool": "Solovis.Reports.Parameters.BoolParameterControl",

        "choice": "Solovis.Reports.Parameters.ChoiceParameterControl",

        "columnSelector": "Solovis.Reports.Parameters.ColumnSelectorParameterControl",

        "compositeSelectionSet": "Solovis.Reports.Parameters.Composites.CompositeSelectionSetParameterControl",

        "contact": "Solovis.Reports.Parameters.ContactParameterControl",

        "currency": "Solovis.Reports.Parameters.CurrencyParameterControl",

        "currencyPair": "Solovis.Reports.Parameters.CurrencyPairParameterControl",

        "dateIndex": "Solovis.Reports.Parameters.DateIndexParameterControl",

        "decimal": "Solovis.Reports.Parameters.DecimalParameterControl",

        "entity": "Solovis.Reports.Parameters.EntityParameterControl",

        "entityOrInvestment": "Solovis.Reports.Parameters.EntityOrInvestmentParameterControl",

        "exposureProfile": "Solovis.Reports.Parameters.ExposureProfileParameterControl",

        "integer": "Solovis.Reports.Parameters.IntegerParameterControl",

        "intervalSet": "Solovis.Reports.Parameters.IntervalSetParameterControl",

        "investment": "Solovis.Reports.Parameters.InvestmentParameterControl",

        "nbdCalendar": "Solovis.Reports.Parameters.NbdCalendarParameterControl",

        "note": "Solovis.Reports.Parameters.NoteParameterControl",

        "property": "Solovis.Reports.Parameters.PropertyParameterControl",

        "report": "Solovis.Reports.Parameters.ReportParameterControl",

        "sourceData": "Solovis.Reports.Parameters.SourceDataParameterControl",

        "statSet": "Solovis.Reports.Parameters.Stats.StatSetParameterControl",

        "string": "Solovis.Reports.Parameters.StringParameterControl",

        "tag": "Solovis.Reports.Parameters.TagParameterControl",

        "tagSet": "Solovis.Reports.Parameters.TagSetParameterControl",

        "transaction": "Solovis.Reports.Parameters.TransactionParameterControl",

        "user": "Solovis.Reports.Parameters.UserParameterControl",

        "utcTimestamp": "Solovis.Reports.Parameters.UtcTimestampParameterControl",

        "valueType": "Solovis.Reports.Parameters.ValueTypeParameterControl",
        
        "horizonPerformanceAdvancedOptions": "Solovis.Reports.Parameters.HorizonPerformance.AdvancedOptionsParameterControl",
    };


    /**
     * Retrieve type name for control for editing parameter of specified parameter type.
     * @param parameterType
     */
    export function getParameterControlForParameterType(parameterType: string): string {
        if (this._parameterTypeToParameterControlMap[parameterType]) {
            return this._parameterTypeToParameterControlMap[parameterType];
        }
        else {
            throw "No parameter control registered for parameter type: " + parameterType;
        }
    }


    export function getParameterTypeList(): string[] {
        var list: string[] = [];
        for (var key in this._parameterTypeToParameterControlMap) {
            list.push(key);
        };

        return list;
    }
}